var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "61px",
    height: "15px",
    viewBox: "0 0 61 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD-Copy",
    transform: "translate(-108.000000, -33.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(108.000000, 33.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    points: "4.45307801 15 0 0 4.57104158 0 6.63538534 9.22852131 6.75334891 9.22852131 9.20106493 0 12.7988791 0 15.2466604 9.25781844 15.3646426 9.25781844 17.4289118 0 22 0 17.546894 15 13.6246614 15 11.0589911 6.62110468 10.9410089 6.62110468 8.37532929 15"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    points: "23.453106 15 19 0 23.5710882 0 25.6354506 9.22852131 25.7534328 9.22852131 28.2011209 0 31.7989724 0 34.2466604 9.25781844 34.3646426 9.25781844 36.4290051 0 41 0 36.5469873 15 32.6246614 15 30.0589911 6.62110468 29.9410089 6.62110468 27.3753386 15"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    points: "56.546894 0 61 15 56.4289118 15 54.3646426 5.77149722 54.2466604 5.77149722 51.7988791 15 48.2010276 15 45.7533396 5.7422001 45.6353574 5.7422001 43.5710882 15 39 15 43.453106 0 47.3753386 0 49.9410089 8.37891385 50.0589911 8.37891385 52.6246614 0"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b966a5e5df6337cdff82ee510fb3e098.svg";
export { ForwardRef as ReactComponent };